/**
 * Shop by Sound — shared utilities
 * - Anchor smooth scroll
 * - Hear button audio (mutex); restore play icon when finished
 */
(function () {
  'use strict';

  /** @type {HTMLAudioElement|null} */
  let currentAudio = null;
  /** @type {HTMLElement|null} */
  let currentBtn = null;

  function setPlaying(btn, playing) {
    if (!btn) return;
    btn.classList.toggle('is-playing', !!playing);
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
  }

  function stopPlayback() {
    if (currentAudio) {
      currentAudio.pause();
      try {
        currentAudio.currentTime = 0;
      } catch (e) {
        /* ignore */
      }
      currentAudio = null;
    }
    if (currentBtn) {
      setPlaying(currentBtn, false);
      currentBtn = null;
    }
  }

  function bindAnchors() {
    document.querySelectorAll('.sbs a[href^="#"]').forEach((link) => {
      if (link.dataset.sbsBound === '1') return;
      link.dataset.sbsBound = '1';

      link.addEventListener('click', (event) => {
        const id = link.getAttribute('href');
        if (!id || id === '#') return;
        const target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function bindAudio() {
    document.querySelectorAll('[data-sbs-hear]').forEach((btn) => {
      if (btn.dataset.sbsBound === '1') return;
      btn.dataset.sbsBound = '1';
      setPlaying(btn, false);

      btn.addEventListener('click', () => {
        const src = btn.getAttribute('data-audio-src');
        if (!src) return;

        // Same button while playing → stop & restore play icon
        if (currentBtn === btn && currentAudio && !currentAudio.paused) {
          stopPlayback();
          return;
        }

        stopPlayback();

        const audio = new Audio(src);
        currentAudio = audio;
        currentBtn = btn;
        setPlaying(btn, true);

        const onDone = () => {
          if (currentAudio === audio) {
            stopPlayback();
          } else {
            setPlaying(btn, false);
          }
        };

        audio.addEventListener('ended', onDone);
        audio.addEventListener('error', onDone);

        audio.play().catch(onDone);
      });
    });
  }

  function boot() {
    bindAnchors();
    bindAudio();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
